// extracted by mini-css-extract-plugin
module.exports = {"wrap":"loader_wrap__6EJCM"};